import { useCurrentUser } from "@/hooks/useUsers";
import { Project } from "@/types/models";

/**
 * Membership test for project contents (setup wizard, documents, evidence
 * base, chat).
 *
 * Access is membership-based: the project owner and the users on the project
 * team. Being an org admin is deliberately NOT enough — an admin who needs to
 * work in a project adds themselves to the project team first. Admins still
 * see every project in the list and can edit project setup, which is how they
 * add themselves.
 */
export function isProjectMember(
  project: Project | undefined,
  userId: string | undefined,
): boolean {
  if (!project || !userId) return false;
  return project.memberIds.includes(userId) || project.createdBy === userId;
}

export function useProjectAccess(project: Project | undefined) {
  const { data: currentUser, isLoading } = useCurrentUser();

  return { hasAccess: isProjectMember(project, currentUser?.id), isLoading };
}
